import { INote } from 'redhotpie-shared-lib/interfaces/IUser';
import * as utils from '../functions/utils';

export default class Note {
  noteId: string;
  userId: string;
  profileNoteMemberId: string;
  createTime: number;
  note: string;

  constructor() {
    this.noteId = '';
    this.userId = '';
    this.profileNoteMemberId = '';
    this.createTime = 0;
    this.note = '';
  }

  static mappingObject(_note: any): INote {
    let note = Object.assign(new Note(), _note);
    note.noteId = _note.noteid;
    note.userId = _note.UserId;
    note.profileNoteMemberId = _note.ProfileNoteMemberId;
    note.createTime = _note.createtime;
    note.note = _note.note;
    note = utils.cleanObjectKeys(Object.keys(new Note()), note);
    return note;
  }

  static mappingObjects(_notes: any): INote[] {
    return _notes.map((note: any) => Note.mappingObject(note));
  }
}
